import { render } from "./invoice_details.vue?vue&type=template&id=60286a2a&scoped=true"
import script from "./invoice_details.vue?vue&type=script&lang=js"
export * from "./invoice_details.vue?vue&type=script&lang=js"

import "./invoice_details.vue?vue&type=style&index=0&id=60286a2a&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60286a2a"]])

export default __exports__